'use client'

import classNames from 'classnames'
import { FC, PropsWithChildren } from 'react'

interface PillProps extends PropsWithChildren {
	color?: string
	radius?: string
	background?: string
}

const Pill: FC<PillProps> = ({
	color = 'black',
	background = 'positive/15',
	radius: round = 'full',
	children,
}) => {
	return (
		<span
			className={classNames(
				`inline-block px-2 lg:px-3 py-1 text-xs font-semibold rounded-${round}`,
				`text-${color} bg-${background} `,
				`max-sm:leading-[120%] max-sm:font-normal max-sm:px-1 max-sm:py-0.5`
			)}
		>
			{children}
		</span>
	)
}

export default Pill
